import { Dialog, Stack } from '@mui/material';
import React, { type PropsWithChildren } from 'react';

import { Loader } from '../layout/loading';
import { PanelWrapper, type PanelWrapperProps } from '../panels/panelWrapper';

export interface MainDialogProps extends PanelWrapperProps {
  isOpen: boolean;
  isLoading: boolean;
}

export function MainDialog(props: PropsWithChildren<MainDialogProps>) {
  const { isLoading, isOpen, header, footer, sx } = props;

  return (
    <Dialog
      onClose={() => {
        header?.onClose?.();
      }}
      onClick={(event) => event.stopPropagation()}
      open={isOpen}
      slotProps={{
        paper: {
          sx: {
            width: '40%',
            maxWidth: '840px',
            minWidth: '600px',
            height: 'max-content',
            minHeight: '300px',
            maxHeight: '90vh',
            borderRadius: '16px',
            ...sx,
          },
        },
      }}
    >
      <PanelWrapper
        rounded
        header={header ? { ...header } : undefined}
        footer={footer ? { ...footer } : undefined}
      >
        <Stack className='h-full py-[24px]'>
          {isLoading && <Loader />}
          {!isLoading && <>{props.children}</>}
        </Stack>
      </PanelWrapper>
    </Dialog>
  );
}
